import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  //HStack,//Vishy 2025-02-18 build warning not used, so removed
  Image,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Text,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai"; //Vishy 2025-02-18 build warning "AiFillMail" not used, so removed
import { MdArrowBack } from "react-icons/md"; // Claude: back button in dark header 27-03-2026
import { Icons } from "../../Assets/icons";
import { Images } from "../../Assets/images"; // Claude: dark header logo 27-03-2026
import { useToastWrapper } from "../../Wrapper/toastWrapper";
import { errorHandler } from "../../Utils/handler";
import { AuthAPI } from "../../Apis/authAPI";
import { useDispatch } from "react-redux";
import actions from "../../redux/Actions";
import { useNavigate } from "react-router-dom";
type Props = {};

const ResetPassword = (props: Props) => {
  const [inputFields, setInputFields] = React.useState({
    oldPassword: "",
    newPassword: "",
  });
  const [loading, setLoading] = React.useState(false);

  const [showPassword, setShowPassword] = React.useState({
    old: false,
    new: false,
  });

  const dispatch = useDispatch();

  const { success, error } = useToastWrapper();

  const navigate = useNavigate();

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setInputFields({
      ...inputFields,
      [name]: value,
    });
  };

  const handleSubmit = async () => {
    if (!inputFields.oldPassword || !inputFields.newPassword)
      return error("Please fill all the fields", "");
    setLoading(true);
    try {
      const res = await AuthAPI.postUpdatePassword(inputFields);
      if (res) {
        success("Password Reset Successfully", "");
        dispatch(actions.user.logout());
        navigate("/");
      }
    } catch (err: any) {
      if (err?.response?.data?.error?.code === 400) {
        error("Old password is incorrect", "");
      } else {
        error(errorHandler(err), "");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box height={"100%"} flexGrow={"grow"} p={6}>
      {/* Claude: dark header with back button 27-03-2026 */}
      <Flex w={"100%"} mx={-6} mt={-6} px={4} py={5} mb={4} width={"calc(100% + 48px)"}
        bg={"#0E122F"} color={"white"} alignItems={"center"} justifyContent={"space-between"}>
        <Flex alignItems="center" gap={3} cursor="pointer" onClick={() => navigate(-1)}>
          <MdArrowBack size={20} color="white" />
          <Text fontSize={"xl"} fontWeight={700}>Change Password</Text>
        </Flex>
        <VStack spacing={0} alignItems="center" justifyContent="center">
          <Image src={Images.AftrLogo} h="32px" objectFit="contain" />
        </VStack>
      </Flex>
      <Text fontSize={"14px"} mt={12}>
        Please enter your new password
      </Text>
      <Box mt={"32px"}>
        <FormControl>
          <FormLabel>Old Password</FormLabel>
          <InputGroup>
            <InputLeftElement h={"50px"} pointerEvents="none">
              <Image src={Icons.LoginPassword} alt="" />
            </InputLeftElement>
            <Input
              value={inputFields.oldPassword}
              name="oldPassword"
              onChange={handleInputChange}
              h={"50px"}
              type={showPassword.old ? "text" : "password"}
              placeholder="Enter password"
            />
            <InputRightElement h={"50px"}>
              {showPassword.old ? (
                <AiFillEyeInvisible
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setShowPassword((prev) => ({
                      ...prev,
                      old: !prev.old,
                    }));
                  }}
                />
              ) : (
                <AiFillEye
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setShowPassword((prev) => ({
                      ...prev,
                      old: !prev.old,
                    }));
                  }}
                />
              )}
            </InputRightElement>
          </InputGroup>
        </FormControl>
        <FormControl mt={"20px"}>
          <FormLabel>New Password</FormLabel>
          <InputGroup>
            <InputLeftElement h={"50px"} pointerEvents="none">
              <Image src={Icons.LoginPassword} alt="" />
            </InputLeftElement>
            <Input
              value={inputFields.newPassword}
              name="newPassword"
              onChange={handleInputChange}
              h={"50px"}
              type={showPassword.new ? "text" : "password"}
              placeholder="Confirm Password"
            />
            <InputRightElement h={"50px"}>
              {showPassword.new ? (
                <AiFillEyeInvisible
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setShowPassword((prev) => ({
                      ...prev,
                      new: !prev.new,
                    }));
                  }}
                />
              ) : (
                <AiFillEye
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setShowPassword((prev) => ({
                      ...prev,
                      new: !prev.new,
                    }));
                  }}
                />
              )}
            </InputRightElement>
          </InputGroup>
        </FormControl>
      </Box>
      <Button
        mt={"80px"}
        width={"full"}
        h={"60px"}
        alignItems={"center"}
        justifyContent={"center"}
        borderRadius={"16px"}
        display={"flex"}
        background={"primary.main"}
        color={"white"}
        _hover={{ background: "#4CAF50" }} // Claude: green hover matches modal confirm buttons 22-02-2026
        onClick={handleSubmit}
      >
        Reset Now
      </Button>
    </Box>
  );
};

export default ResetPassword;
